import { createStore, GetterTree, MutationTree, ActionTree } from "vuex";
import services from "./modules/services";
import simRemittances from "./modules/SimRemittances";
import cardRemittances from "./modules/CardRemittances";
import cardRemittancesMerchant from "./modules/CardRemittancesMerchant";

import { RootState } from "@/util/interface";
import { request } from "@/api/request";
import { DEFAULT } from "@/constant";

const state: RootState = {
  token: "",
  merchant: "",
  loading: false,
  operator: {},
  senderOperator: {},
  receiverOperator: {},
  refillOperator: {},
  bankTransferOperator: {},
  receiptOperator: {},
  JsSDK: {},
  prevRoute: "",
  services: services.state,
  simRemittances: simRemittances.state,
  cardRemittances: cardRemittances.state,
  cardRemittancesMerchant: cardRemittancesMerchant.state,
  refreshToken: false,
  language: "",
  otp: {},
  paymentOtpData: {},
};

const getters: GetterTree<RootState, RootState> = {
  token: (state) => state.token,
  JsSDK: (state) => state.JsSDK,
  refreshToken: (state) => state.refreshToken,
  prevRoute: (state) => state.prevRoute,
  merchant: (state) => state.merchant,
  isDefault: (state) => state.merchant === DEFAULT,
  loading: (state) => state.loading,
  operator: (state) => state.operator,
  senderOperator: (state) => state.senderOperator,
  receiverOperator: (state) => state.receiverOperator,
  receiptOperator: (state) => state.receiptOperator,
  refillOperator: (state) => state.refillOperator,
  bankTransferOperator: (state) => state.bankTransferOperator,
  language: (state) => state.language,
  otp: (state) => state.otp,
  paymentOtpData: (state) => state.paymentOtpData,
};

const actions: ActionTree<RootState, RootState> = {
  async checkOperator({ commit }, data) {
    await request({ url: "mnp/check", method: "post", data }).then((res) => {
      commit("setOperator", { ...res.data, type: data.type });
    });
  },
};

const mutations: MutationTree<RootState> = {
  setJsSDK: (state, payload) => {
    state.JsSDK = payload;
  },
  setToken: (state, payload) => {
    state.token = payload;
  },
  setLoading: (state, payload) => {
    state.loading = payload;
  },
  setMerchant: (state, payload) => {
    state.merchant = payload;
  },
  setPrevRoute: (state, payload) => {
    state.prevRoute = payload;
  },
  setRefreshToken: (state, payload) => {
    state.refreshToken = payload;
  },
  setLanguage: (state, payload) => {
    state.language = payload;
  },
  setOperator: (state, payload) => {
    if (payload.type === "sender") {
      state.senderOperator = payload;
    } else if (payload.type === "receiver") {
      state.receiverOperator = payload;
    } else if (payload.type === "sim") {
      state.refillOperator = payload;
    } else if (payload.type === "card") {
      state.bankTransferOperator = payload;
    } else if (payload.type === "receipt") {
      state.receiptOperator = payload;
    } else {
      state.operator = payload;
    }
  },
  clearOperator: (state) => {
    state.senderOperator = {};
    state.receiverOperator = {};
    state.refillOperator = {};
    state.bankTransferOperator = {};
    state.receiptOperator = {};
    state.operator = {};
  },
  setOtp: (state, payload) => {
    state.otp = payload;
  },
  setPaymentOtpData: (state, payload) => {
    state.paymentOtpData = payload;
  },
};

export default createStore({
  state,
  getters,
  actions,
  mutations,
  modules: {
    services,
    simRemittances,
    cardRemittances,
    cardRemittancesMerchant,
  },
});
